module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABECAYAAAA4E5OyAAAAAXNSR0IArs4c6QAAAKxJREFUeAHt2DESgCAMBED0/3/W/qrgjBpl6W6GIlnSkDEcAgQIECBAgAABAgQIECBAgMBaAttEu8fE3Y5XS73uHSt/syYgoQ8ESAhENCEBIhIgQIAAAQIECBDoKVDaEVwsvdv+pNSrv0y8NhAgIRDRhAAJAZEAAQIECBAgQIDAJwRKO4KbO3lqb1Lq1ecuXhsIkBCIaEKAhIBIgAABAgQIECBAgAABAgR+L3ACAK8DIpOTkhkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon-menu-black.png
// module id = hS8Q
// module chunks = 0